import { render, staticRenderFns } from "./ForumContentPlaceholder.vue?vue&type=template&id=3b93ba03&"
import script from "./ForumContentPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./ForumContentPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports